import React from 'react';

function ReturnPolicy() {
  return (
  <>
  <div className='container'>
    <div className='row'>
      <div className='col-sm-12'>
        <h1 style={{textAlign: "left", marginTop: 10}}>WARRANTY / RETURN POLICY</h1>
        <p style={{marginTop: 5}}>Last updated: Oct. 1 2026</p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>WHAT DOES THIS WARRANTY COVER?</h5>
        <p style={{marginRight: 50}}>
          This warranty covers parts purchased from FitnessRepairParts.com against defects in material and workmanship when they are used for their intended purpose, under normal conditions and provided the unit they are installed on receives proper care.
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>HOW LONG DOES THIS WARRANTY LAST?</h5>
        <ul style={{marginRight: 50}}>
          <li>Non-electronic parts carry a 30 day warranty, from delivery date of original order</li>
          <li>Electronic parts carry a 30 day warranty, from delivery date of original order</li>
        </ul>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>HOW WILL FitnessRepairParts.com SATISFY THIS WARRANTY?</h5>
        <p style={{marginRight: 50}}>
          FitnessRepairParts.com will provide a replacement part at no additional charge (excluding the cost for shipping the part back to us) for any part found by us to be defective due to workmanship or materials, provided you follow the stated return policy listed below.
        </p>
        <p style={{marginRight: 50}}>
          <strong>Note: We replace defective or damaged parts; we do not provide full refunds for defective or damaged parts. </strong>
          If you wish to RETURN a defective or damaged part rather than have the part replaced the refund is subject to both restocking and electronics inspection/testing fees.
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>WHAT IS NOT COVERED BY THIS WARRANTY?</h5>
        <p>This warranty does NOT cover:</p>
        <ul style={{marginRight: 50}}>
          <li>
            Parts for Residential equipment used in a Commercial or Income producing locations (Health Clubs, Hotels, Corporate Fitness Centers, Schools, Senior Centers, or Home-Based Personal Training)
          </li>
          <li>Parts subjected to misuse, abuse, or neglect, as determined by FitnessRepairParts.com</li>
          <li>
            Parts altered, tampered with, or damaged during installation or shipping. 
            <strong> If your part was damaged during shipping, you must notify us within 3 business days of receipt.</strong>
          </li>
        </ul>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>HOW DO I GET A REPLACEMENT PART?</h5>
        <p style={{marginRight: 50}}>
          Click the &quot;Orders and Returns&quot; button on the top of the website, within the above specified warranty period, to obtain a Return Authorization (RA) number. Follow all instructions. Once you have the RA number you will be required to return the item within 15 days. ALL RAs EXPIRE 15 DAYS AFTER ISSUANCE. After we receive and inspect the defective part, we will ship out a replacement part within 30 days.
        </p>
        <p style={{marginRight: 50}}>
          <i>NOTE: We reserve the right to refuse replacement of the part if the item shows signs of not being covered by the warranty as noted above. Any parts returned to us that are determined to not qualify for replacement can be returned to you if you provide a return label for the return shipping of these items. We will hold the items for 7 days after you return them to us, after 7 days we will dispose of them.</i>
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>HOW DO I GET A RETURN AUTHORIZATION (RA) NUMBER?</h5>
        <p style={{marginRight: 50}}>
          Click the &quot;Orders and Returns&quot; button on the top of the website, within the above specified warranty period, to obtain a Return Authorization (RA) number. 
          <strong> On some RA types we will require you to provide the brand, model number, and serial number from the exercise equipment. </strong> 
          You must have an RA number to return parts to us. Parts returned without an RA WILL be refused and shipped back, collect, to the shipper.
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <h5 style={{marginTop: 20, fontWeight: 'bold'}}>RETURNS</h5>
        <ul style={{marginRight: 50}}>
		      <li>RA for a refund must be requested within 30 days of receipt of the product.</li>
		      <li>All returns of non-electrical parts (except for defective parts) are subject to a 20% restocking fee.</li>
		      <li>Returns of electrical or electronic parts (except for defective parts) are subject to a 25% restocking fee.</li>
		      <li>Accounts at volume discount level 2 or 3 are not charged a restocking fee.</li>
		      <li>The RA number must be written in 2 locations on the outside of the box.</li>
		      <li>A signed copy of the original packing slip must be inside the box.</li>
		      <li>
            Return the part, with shipping pre-paid, to FitnessRepairParts.com, 650 N Main Center, Suite 101, St. Charles, MO 63301. 
            <br /><strong>Note: NO COLLECT </strong> 
            packages will be accepted, you must pay the return shipping.
          </li>
		      <li>
            Any package that is refused or un-deliverable to you will be charged return shipping to us by the shipping company. We will deduct this return shipping from any refund that you are entitled to receive.
          </li>
		      <li>
            Only non-used parts can be returned for a refund; if you install it, you own it. The above defective parts warranty is still in effect and we will 
            <i>replace</i> parts returned and determined by us to be defective.
          </li>
		      <li>We will NOT refund shipping & handling charges on any returned items; this includes defective parts.</li>
		      <li>
            Refunds for parts that put the remainder of an order below the $25 minimum order will be adjusted to meet that minimum requirement for the rest of the order. Minimum order fees are never refunded.
          </li>
		      <li>
            You may be required to attach a picture of the model number/serial number from your equipment and parts comparison pictures for some RAs. If pictures are requested and the part is returned to us before pictures arrive, the RA will be handled as a normal refund and subject to the restocking fee (25% for electrical or electronic parts, 20% for other parts).
          </li>
		      <li>Allow up to 30 days, from our receipt of the package, for your refund to be processed and issued back to you.</li>
	      </ul>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <p style={{marginTop: 20, marginRight: 50}}>
          A $25 fee will be accessed, for any erroneous challenge to a legitimate credit card charge, which results in a charge back fee to FitnessRepairParts.com. We aggressively defend against charge backs and allow collections agency to collect on our behalf.
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <p style={{marginTop: 20}}>We always suggest using a trained service technician to diagnose, repair and maintain your equipment.</p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <p style={{marginTop: 20, marginRight: 50}}>
          <strong>Note:</strong> We start researching issues immediately after the required information above is received from you; however, please allow up to 30 days from that date to determine and correct valid issues presented to our research team.
        </p>
      </div>
    </div>
    <div className='row'>
      <div className='col-sm-12'>
        <p style={{marginTop: 20}}>
          PLEASE REMEMBER TO ALWAYS USE A MODEL NUMBER WHEN ORDERING PARTS. Check out our 
          <a href="/searchtips.php"> search tips</a>. 
          Thanks for choosing FitnessRepairParts.com!
        </p> 	
      </div>
    </div>
  </div>

  <p style={{textAlign: "center", marginTop: 20}}>
    Did this help? 
    <a href="https://www.fitnessrepairparts.com/"> Continue shopping</a>.
  </p>
  <p style={{marginBottom: 20, textAlign: "center"}}>
    Still have questions? 
    <a href="https://www.fitnessrepairparts.com/ticket.php?action=kb"> F.A.Q.</a> or 
    <a href="https://www.fitnessrepairparts.com/ticket.php?action=open"> contact us</a>.
  </p>
  </>    
  );
};

export default ReturnPolicy;